// removed by extract-text-webpack-plugin
module.exports = {"mainTableClass":"styles__mainTableClass___27ouj","scrollTableClass":"styles__scrollTableClass___2b25z","defaultContainerClass":"styles__defaultContainerClass___3XhNm","positionModalClass":"styles__positionModalClass___3W5e0","buttonCellClass":"styles__buttonCellClass___oSv_C"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/History/styles.css
// module id = 2872
// module chunks = 0